module.exports = {
	"id": "GP",
	"name": "Guadeloupe",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.012996,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.012996,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.42237,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.025992,
			"32": null,
			"33": null,
			"34": 0.012996,
			"35": 0.03249,
			"36": 0.019494,
			"37": 0.090972,
			"38": 0.019494,
			"39": 0.03249,
			"40": 0.071478,
			"41": 0.012996,
			"42": 0.038988,
			"43": 0.090972,
			"44": 0.045486,
			"45": 0.019494,
			"46": 0.038988,
			"47": 0.084474,
			"48": 0.038988,
			"49": 1.221624,
			"50": 0.077976,
			"51": 0.500346,
			"52": 0.428868,
			"53": 24.094584,
			"54": 7.232274,
			"55": 0.045486,
			"56": 0.019494,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": 0.012996,
			"14": null,
			"15": null,
			"16": 0.012996,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.012996,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.012996,
			"25": 0.038988,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.012996,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.025992,
			"35": 0.006498,
			"36": null,
			"37": 0.006498,
			"38": 0.077976,
			"39": 0.051984,
			"40": 0.038988,
			"41": 0.012996,
			"42": 0.019494,
			"43": 0.110466,
			"44": 0.03249,
			"45": 0.116964,
			"46": 0.058482,
			"47": 0.350892,
			"48": 0.734274,
			"49": 7.511688,
			"50": 0.025992,
			"51": 0.03249,
			"52": null,
			"3.5": null,
			"3.6": 0.077976
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.051984,
			"37": 0.012996,
			"38": 0.019494,
			"39": 0.025992,
			"40": 0.526338,
			"41": 0.084474,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.012996,
			"11.6": null,
			"12.1": 0.045486
		},
		"safari": {
			"0": null,
			"4": 0.006498,
			"5": 0.110466,
			"6": 0.03249,
			"7": 0.084474,
			"8": 0.318402,
			"9": 0.331398,
			"10": 2.560212,
			"3.1": null,
			"3.2": null,
			"5.1": 0.214434,
			"6.1": 0.25992,
			"7.1": 0.006498,
			"9.1": 1.936404
		},
		"ios_saf": {
			"8": 0,
			"10": 4.20857588343,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.113416250208,
			"8.1-8.4": 0.209531716486,
			"9.0-9.2": 0.0999600849292,
			"9.3": 1.52503206495
		},
		"android": {
			"3": 0,
			"4": 0.0335721447028,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00419651808786,
			"4.1": 0.121099521964,
			"4.2-4.3": 0.30274880491,
			"4.4": 0.694223992248,
			"4.4.3-4.4.4": 0.700219018088
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.103968,
			"9": 0.136458,
			"10": 0.207936,
			"11": 4.477122,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00917727297714,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000254924249365
		},
		"edge": {
			"12": 0.246924,
			"13": 1.124154,
			"14": 2.885112
		},
		"ie_mob": {
			"10": 0.0524806760563,
			"11": 0.213671323944
		},
		"bb": {
			"7": 0.014008,
			"10": null
		},
		"samsung": {
			"0": 4.923812
		},
		"and_uc": {
			"0": 0.059534
		},
		"op_mini": {
			"0": 0.123643802773
		},
		"and_chr": {
			"0": 24.942438
		},
		"and_ff": {
			"0": 0.028016
		}
	},
	"total": 98.343156
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GP.json
 ** module id = 535
 ** module chunks = 0
 **/